export const Obtain_Music_Score_Details = 'scoreParticulars/Obtain_Music_Score_Details';
export const Update_Load_State= 'scoreParticulars/Update_Load_State';
